import { Component, Input, OnInit } from '@angular/core';
import { DataEntityEnvironment_Interface, Empty_DataEntityEnvironment_Interface } from 'src/app/Interface/DataEntity/DataEntityEnvironment_Interface';
import { Device_Interface, Empty_Device_Interface } from 'src/app/Interface/Device_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DataEntityEnvironmentService } from 'src/app/Service/DataEntity/DataEntityEnvironment.service';

@Component({
  selector: 'app-DataEntityEnvironment',
  templateUrl: './DataEntityEnvironment.component.html',
  styleUrls: ['./DataEntityEnvironment.component.css']
})
export class DataEntityEnvironmentComponent implements OnInit {

  @Input() inner_Device: Device_Interface = Empty_Device_Interface()
  Procssing:boolean=false

  constructor(
    private Alertify_Service:AlertifyService,
    private DataEntityEnvironment_Service:DataEntityEnvironmentService,
  ) { }

  ngOnInit() {
    this.Read_DataentityEnvironment()
  }

  DataentityEnvironment_DataList:Array<DataEntityEnvironment_Interface>=[]
  Read_DataentityEnvironment() {
    this.Procssing = true
    this.DataEntityEnvironment_Service.GetRecord(this.inner_Device.id).subscribe(
      data => {
        this.DataentityEnvironment_DataList = data
        this.Procssing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  Submit() {
    this.Procssing = true
    this.DataEntityEnvironment_Service.Submit(this.DataentityEnvironment_DataList,this.inner_Device.id).subscribe(
      data => {
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        this.Procssing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }


}
